import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useMemo } from 'react';
import { Role } from '../types/user';

interface UseAuthUserInfoResult {
  userId: string | null;
  userRole: Role | null;
  hasRole: (...requiredRole: Role[]) => boolean;
}

const useAuthUserInfo = (): UseAuthUserInfoResult => {
  const { accounts, inProgress } = useMsal();

  let userRole: Role | null = null;
  let userId: string | null = null;

  if (inProgress !== InteractionStatus.Startup && accounts.length > 0) {
    const [account] = accounts;
    const idTokenClaims = account.idTokenClaims as
      | { extension_UserRole?: string; oid?: string }
      | undefined;
    const tokenRole = idTokenClaims?.extension_UserRole ?? null;
    userRole = Object.values(Role).find(role => role === tokenRole) ?? null;
    userId = idTokenClaims?.oid ?? null;
  }

  const hasRole = useMemo(
    () =>
      !userRole
        ? () => false
        : (...requiredRoles: Role[]) =>
            requiredRoles.some(requiredRole => userRole === requiredRole),
    [userRole],
  );

  return {
    userId,
    userRole,
    hasRole,
  };
};

export default useAuthUserInfo;
